import { Include, ScheduledSurgery, Surgery, SurgeryFolderMetadatum, UnScheduledSurgery } from '~/storm'

type SurgeryWithFolderMetadata = Include<ScheduledSurgery | UnScheduledSurgery, { surgeryFolderMetadata: true }>

function hasFolderMetadata(surgery: Surgery): surgery is SurgeryWithFolderMetadata {
    return 'surgeryFolderMetadata' in surgery && surgery.surgeryFolderMetadata !== undefined
}

export function getSurgeryMetadata(surgery: Surgery): SurgeryFolderMetadatum | undefined {
    return hasFolderMetadata(surgery) ? surgery.surgeryFolderMetadata : undefined
}
